/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Routemize_DTOs_SmsIntegration_ConnectOpenPhoneDto } from '../models/Routemize_DTOs_SmsIntegration_ConnectOpenPhoneDto';
import type { Routemize_DTOs_SmsIntegration_ConnectRingCentralDto } from '../models/Routemize_DTOs_SmsIntegration_ConnectRingCentralDto';
import type { Routemize_DTOs_SmsIntegration_ConnectTwilioDto } from '../models/Routemize_DTOs_SmsIntegration_ConnectTwilioDto';
import type { Routemize_DTOs_SmsIntegration_RingCentralNumbersResultDto } from '../models/Routemize_DTOs_SmsIntegration_RingCentralNumbersResultDto';
import type { Routemize_DTOs_SmsIntegration_SmsDeliveryHealthDto } from '../models/Routemize_DTOs_SmsIntegration_SmsDeliveryHealthDto';
import type { Routemize_DTOs_SmsIntegration_SmsIntegrationSettingsDto } from '../models/Routemize_DTOs_SmsIntegration_SmsIntegrationSettingsDto';
import type { Routemize_DTOs_SmsIntegration_TestOpenPhoneConnectionDto } from '../models/Routemize_DTOs_SmsIntegration_TestOpenPhoneConnectionDto';
import type { Routemize_DTOs_SmsIntegration_TestOpenPhoneConnectionResultDto } from '../models/Routemize_DTOs_SmsIntegration_TestOpenPhoneConnectionResultDto';
import type { Routemize_DTOs_SmsIntegration_TestTwilioConnectionDto } from '../models/Routemize_DTOs_SmsIntegration_TestTwilioConnectionDto';
import type { Routemize_DTOs_SmsIntegration_TestTwilioConnectionResultDto } from '../models/Routemize_DTOs_SmsIntegration_TestTwilioConnectionResultDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SmsIntegrationService {
    /**
     * @returns Routemize_DTOs_SmsIntegration_SmsIntegrationSettingsDto OK
     * @throws ApiError
     */
    public static getApiAppSmsIntegrationGetSettings(): CancelablePromise<Routemize_DTOs_SmsIntegration_SmsIntegrationSettingsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/smsIntegration/getSettings',
        });
    }
    /**
     * @returns Routemize_DTOs_SmsIntegration_SmsDeliveryHealthDto OK
     * @throws ApiError
     */
    public static getApiAppSmsIntegrationGetSmsDeliveryHealth(): CancelablePromise<Routemize_DTOs_SmsIntegration_SmsDeliveryHealthDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/smsIntegration/getSmsDeliveryHealth',
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_SmsIntegration_TestOpenPhoneConnectionResultDto OK
     * @throws ApiError
     */
    public static postApiAppSmsIntegrationTestConnection(
        requestBody?: Routemize_DTOs_SmsIntegration_TestOpenPhoneConnectionDto,
    ): CancelablePromise<Routemize_DTOs_SmsIntegration_TestOpenPhoneConnectionResultDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/smsIntegration/testConnection',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppSmsIntegrationConnect(
        requestBody?: Routemize_DTOs_SmsIntegration_ConnectOpenPhoneDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/smsIntegration/connect',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppSmsIntegrationDisconnect(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/smsIntegration/disconnect',
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_SmsIntegration_TestTwilioConnectionResultDto OK
     * @throws ApiError
     */
    public static postApiAppSmsIntegrationTestTwilioConnection(
        requestBody?: Routemize_DTOs_SmsIntegration_TestTwilioConnectionDto,
    ): CancelablePromise<Routemize_DTOs_SmsIntegration_TestTwilioConnectionResultDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/smsIntegration/testTwilioConnection',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppSmsIntegrationConnectTwilio(
        requestBody?: Routemize_DTOs_SmsIntegration_ConnectTwilioDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/smsIntegration/connectTwilio',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppSmsIntegrationDisconnectTwilio(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/smsIntegration/disconnectTwilio',
        });
    }
    /**
     * @param returnUrl
     * @returns string OK
     * @throws ApiError
     */
    public static getApiAppSmsIntegrationGetRingCentralAuthorizeUrl(
        returnUrl?: string,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/smsIntegration/getRingCentralAuthorizeUrl',
            query: {
                'returnUrl': returnUrl,
            },
        });
    }
    /**
     * @returns Routemize_DTOs_SmsIntegration_RingCentralNumbersResultDto OK
     * @throws ApiError
     */
    public static getApiAppSmsIntegrationGetRingCentralNumbers(): CancelablePromise<Routemize_DTOs_SmsIntegration_RingCentralNumbersResultDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/smsIntegration/getRingCentralNumbers',
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppSmsIntegrationConnectRingCentral(
        requestBody?: Routemize_DTOs_SmsIntegration_ConnectRingCentralDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/smsIntegration/connectRingCentral',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppSmsIntegrationDisconnectRingCentral(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/smsIntegration/disconnectRingCentral',
        });
    }
}
